var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.47 74.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 37.23,
    cy: 37.23,
    r: 37.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.39,287.88V270.45a4.56,4.56,0,0,1,3.93-4.64,4.25,4.25,0,0,1,.8-.05h27.19a4.56,4.56,0,0,1,4.69,4.7v34.85a4.55,4.55,0,0,1-4.68,4.69H210.06a4.53,4.53,0,0,1-4.63-4,4.59,4.59,0,0,1,0-.74Zm32.9-10.66H209.1v27.95c0,.82.3,1.12,1.13,1.12h26.92c.83,0,1.14-.3,1.14-1.12V277.22Zm-29.19-3.78h29.17c0-1.08,0-2.14,0-3.2,0-.48-.41-.76-.95-.76H210.07a.88.88,0,0,0-1,.94c0,.5,0,1,0,1.48Z",
    transform: "translate(-185.59 -250.65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.71,290.79h10.62a.93.93,0,0,1,1,.8.89.89,0,0,1-.79,1,2.23,2.23,0,0,1-.37,0h-21a2.38,2.38,0,0,1-.46,0,.89.89,0,0,1,0-1.74,1.71,1.71,0,0,1,.39,0Z",
    transform: "translate(-185.59 -250.65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.66,287.55H213a.92.92,0,0,1-1-.78.89.89,0,0,1,.77-1,1.51,1.51,0,0,1,.3,0h21.18c.66,0,1.07.34,1.08.88a.88.88,0,0,1-.74.91,1.94,1.94,0,0,1-.34,0Z",
    transform: "translate(-185.59 -250.65)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.69,297.89H213a.92.92,0,0,1-1-.93.9.9,0,0,1,.84-.86h21.45a1.71,1.71,0,0,1,.46,0,.89.89,0,0,1,.59,1,.91.91,0,0,1-.8.77H223.69Z",
    transform: "translate(-185.59 -250.65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.69,280.5h10.62a1.54,1.54,0,0,1,.48.06.89.89,0,0,1,.57.95.92.92,0,0,1-.8.78H213.17a1.77,1.77,0,0,1-.52-.05.87.87,0,0,1-.62-1,.89.89,0,0,1,.83-.77h10.83Z",
    transform: "translate(-185.59 -250.65)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.69,301.31h10.62c.61,0,1,.3,1.05.81a.91.91,0,0,1-.83,1H213.14a1.75,1.75,0,0,1-.46,0,.89.89,0,0,1,.18-1.75h10.83Z",
    transform: "translate(-185.59 -250.65)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentNotes);
export default __webpack_public_path__ + "static/media/recent_notes.2234afcd8a65fe1a799459e74adcdd51.svg";
export { ForwardRef as ReactComponent };